import * as React from 'react';
import * as Select from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Root = Select.Root;
export const Value = Select.Value;

export const Trigger = React.forwardRef<
  React.ElementRef<typeof Select.Trigger>,
  React.ComponentPropsWithoutRef<typeof Select.Trigger>
>(({ className, children, ...props }, ref) => (
  <Select.Trigger
    ref={ref}
    className={cn('flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm', className)}
    {...props}
  >
    {children}
    <Select.Icon><ChevronDown className="h-4 w-4 opacity-50" /></Select.Icon>
  </Select.Trigger>
));
Trigger.displayName = 'SelectTrigger';

export const Content = React.forwardRef<
  React.ElementRef<typeof Select.Content>,
  React.ComponentPropsWithoutRef<typeof Select.Content>
>(({ className, children, ...props }, ref) => (
  <Select.Portal>
    <Select.Content ref={ref} className={cn('z-50 overflow-hidden rounded-md border bg-background shadow-md', className)} {...props}>
      <Select.Viewport className="p-1">{children}</Select.Viewport>
    </Select.Content>
  </Select.Portal>
));
Content.displayName = 'SelectContent';

export const Item = React.forwardRef<
  React.ElementRef<typeof Select.Item>,
  React.ComponentPropsWithoutRef<typeof Select.Item>
>(({ className, children, ...props }, ref) => (
  <Select.Item
    ref={ref}
    className={cn('relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-muted', className)}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <Select.ItemIndicator><Check className="h-4 w-4" /></Select.ItemIndicator>
    </span>
    <Select.ItemText>{children}</Select.ItemText>
  </Select.Item>
));
Item.displayName = 'SelectItem';
